import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { PermissionService } from '../services';
@Injectable({
  providedIn: 'root',
})
export class RedirectGuard implements CanActivate {
  constructor(
    private permissionService: PermissionService,
    private router: Router
  ) {}

    canActivate(): boolean {
        const routePermissions = [
            { path: '/EzynessAdmin/Reporting', policy: 'EzynessAdmin.Reporting' },
            { path: '/Enroment/TDB', policy: 'Enrolment.TDB' },
            { path: '/Enroment/TDBLPR', policy: 'Enrolment.TDBLPR' },
        ];
        for (const route of routePermissions) {
            if (this.permissionService.getGrantedPolicy(route.policy)) {
                this.router.navigate([route.path]);
                return false;
            }
        }
        this.router.navigate(['/account/manage-profile']);
        return false;
    }
}
